import Vue from "vue";

Vue.component("user-activities", {
    data()
    {
        return {
            activities: [],
            isLoading: true,
            currentPage: 1,
            itemsPerPage: 10
        };
    },

    mounted()
    {
        this.loadActivities();
    },

    computed: {
        totalPages()
        {
            return Math.ceil(this.activities.length / this.itemsPerPage);
        },

        paginatedActivities()
        {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.activities.slice(start, end);
        },

        paginationInfo()
        {
            const start = (this.currentPage - 1) * this.itemsPerPage + 1;
            const end = Math.min(this.currentPage * this.itemsPerPage, this.activities.length);
            const total = this.activities.length;
            
            if (total === 0) {
                return "Keine Interaktionen";
            }
            
            return `${start}-${end} von ${total} Interaktionen`;
        }
    },

    methods: {
        loadActivities()
        {
            const self = this;

            $.ajax({
                url: "/rest/fanliebling/user/activities",
                method: "GET",
                success: function(response)
                {
                    if (response.data && response.data.activities)
                    {
                        self.activities = response.data.activities;
                    }
                    self.isLoading = false;
                },
                error: function()
                {
                    self.isLoading = false;
                }
            });
        },

        deleteActivity(activityId, activityType)
        {
            const self = this;

            // Bestätigung vor dem Löschen
            if (!confirm("Möchtest du diese Aktivität wirklich löschen?"))
            {
                return;
            }

            $.ajax({
                url: "/rest/fanliebling/user/activities/" + activityId,
                method: "DELETE",
                success: function(response)
                {
                    if (response.success)
                    {
                        // Entferne die Aktivität aus dem Array
                        self.activities = self.activities.filter(function(activity)
                        {
                            return activity.id !== activityId;
                        });
                    }
                },
                error: function(xhr)
                {
                    let errorMsg = "Die Aktivität konnte nicht gelöscht werden.";

                    try
                    {
                        const response = JSON.parse(xhr.responseText);

                        if (response.error && response.error.message)
                        {
                            errorMsg = response.error.message;
                        }
                    }
                    catch (error)
                    {
                        // Error handling
                    }

                    alert(errorMsg);
                }
            });
        },

        getActivityTypeName(type)
        {
            const types = {
                vote: "Vote",
                transfer_check: "Transfer-Check",
                rumor_probability: "Gerücht-Einschätzung",
                player_comparison_vote: "Spielervergleich",
                team_impact: "Team Impact",
                feedback: "Kommentar",
                start_bench_sell_vote: "Start - Bench - Sell"
            };

            return types[type] || type;
        },

        getActivityIcon(type)
        {
            const icons = {
                vote: "fa fa-heart",
                transfer_check: "fa fa-check-circle",
                rumor_probability: "fa fa-percent",
                player_comparison_vote: "fa fa-users",
                team_impact: "fa fa-star",
                feedback: "fa fa-comment",
                start_bench_sell_vote: "fa fa-trophy"
            };

            return icons[type] || "fa fa-circle";
        },

        getActivityClass(type)
        {
            const classes = {
                vote: "badge badge-danger",
                transfer_check: "badge badge-success",
                rumor_probability: "badge badge-info",
                player_comparison_vote: "badge badge-primary",
                team_impact: "badge badge-warning",
                feedback: "badge badge-secondary",
                start_bench_sell_vote: "badge badge-dark"
            };

            return classes[type] || "badge badge-secondary";
        },

        formatDate(dateString)
        {
            const date = new Date(dateString);

            return date.toLocaleDateString("de-DE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            });
        },

        nextPage()
        {
            if (this.currentPage < this.totalPages)
            {
                this.currentPage++;
            }
        },

        previousPage()
        {
            if (this.currentPage > 1)
            {
                this.currentPage--;
            }
        },

        goToPage(page)
        {
            if (page >= 1 && page <= this.totalPages)
            {
                this.currentPage = page;
            }
        }
    },

    render: function(createElement)
    {
        const self = this;

        // Erstelle Pagination-Buttons
        const paginationButtons = [];
        if (this.totalPages > 1) {
            // Vorherige Seite Button
            paginationButtons.push(
                createElement(
                    "button",
                    {
                        class: "btn btn-sm btn-secondary mr-2 d-flex align-items-center" + (this.currentPage === 1 ? " disabled" : ""),
                        on: {
                            click: function() {
                                self.previousPage();
                            }
                        },
                        attrs: {
                            disabled: this.currentPage === 1
                        }
                    },
                    [
                        createElement("i", { class: "fa fa-chevron-left mr-1" }),
                        "Zurück"
                    ]
                )
            );

            // Seiten-Buttons
            const maxButtons = 5;
            let startPage = Math.max(1, this.currentPage - Math.floor(maxButtons / 2));
            let endPage = Math.min(this.totalPages, startPage + maxButtons - 1);
            
            if (endPage - startPage + 1 < maxButtons) {
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                const page = i;
                paginationButtons.push(
                    createElement(
                        "button",
                        {
                            class: "btn btn-sm " + (this.currentPage === page ? "btn-primary" : "btn-outline-secondary") + " mr-1",
                            on: {
                                click: function() {
                                    self.goToPage(page);
                                }
                            }
                        },
                        String(page)
                    )
                );
            }

            // Nächste Seite Button
            paginationButtons.push(
                createElement(
                    "button",
                    {
                        class: "btn btn-sm btn-secondary ml-1 d-flex align-items-center" + (this.currentPage === this.totalPages ? " disabled" : ""),
                        on: {
                            click: function() {
                                self.nextPage();
                            }
                        },
                        attrs: {
                            disabled: this.currentPage === this.totalPages
                        }
                    },
                    [
                        "Weiter",
                        createElement("i", { class: "fa fa-chevron-right ml-1" })
                    ]
                )
            );
        }

        const contentElements = [
            createElement("h3", { class: "mb-4" }, "Meine Leistungen"),

            this.isLoading
                ? createElement("div", { class: "text-center py-5" }, [
                    createElement("i", {
                        class: "fa fa-spinner fa-spin fa-3x"
                    }),
                    createElement(
                        "p",
                        { class: "mt-3" },
                        "Lade Aktivitäten..."
                    )
                ])
                : this.activities.length === 0
                    ? createElement("div", { class: "alert alert-info" }, [
                        createElement("i", {
                            class: "fa fa-info-circle mr-2"
                        }),
                        "Noch keine Aktivitäten vorhanden."
                    ])
                    : createElement("div", { class: "table-responsive" }, [
                                createElement(
                                    "table",
                                    { class: "table table-striped table-hover" },
                                    [
                                        createElement("thead", {}, [
                                            createElement("tr", {}, [
                                                createElement("th", {}, "Typ"),
                                                createElement(
                                                    "th",
                                                    {},
                                                    "Beschreibung"
                                                ),
                                                createElement(
                                                    "th",
                                                    {},
                                                    "Gerücht"
                                                ),
                                                createElement("th", {}, "Datum"),
                                                createElement("th", { style: { width: "100px", textAlign: "center" } }, "Aktionen")
                                            ])
                                        ]),
                                        createElement(
                                            "tbody",
                                            {},
                                            this.paginatedActivities.map(function(
                                                activity
                                            )
                                            {
                                                return createElement(
                                                    "tr",
                                                    { key: activity.id },
                                                    [
                                                        createElement("td", {}, [
                                                            createElement(
                                                                "span",
                                                                {
                                                                    class: self.getActivityClass(
                                                                        activity.type
                                                                    )
                                                                },
                                                                [
                                                                    createElement(
                                                                        "i",
                                                                        {
                                                                            class: self.getActivityIcon(
                                                                                activity.type
                                                                            )
                                                                        }
                                                                    ),
                                                                    " " +
                                                                      self.getActivityTypeName(
                                                                          activity.type
                                                                      )
                                                                ]
                                                            )
                                                        ]),
                                                        createElement(
                                                            "td",
                                                            {},
                                                            activity.description
                                                        ),
                                                        createElement(
                                                            "td",
                                                            {},
                                                            activity.item
                                                                ? [
                                                                    createElement(
                                                                        "a",
                                                                        {
                                                                            attrs: {
                                                                                href:
                                                                                    activity
                                                                                        .item
                                                                                        .url
                                                                            },
                                                                            class:
                                                                                "text-primary"
                                                                        },
                                                                        activity
                                                                            .item
                                                                            .name
                                                                    )
                                                                ]
                                                                : ["-"]
                                                        ),
                                                        createElement(
                                                            "td",
                                                            {},
                                                            self.formatDate(
                                                                activity.date
                                                            )
                                                        ),
                                                        createElement(
                                                            "td",
                                                            {
                                                                style: {
                                                                    textAlign: "center"
                                                                }
                                                            },
                                                            [
                                                                createElement(
                                                                    "button",
                                                                    {
                                                                        class: "btn btn-sm btn-danger",
                                                                        on: {
                                                                            click: function()
                                                                            {
                                                                                self.deleteActivity(activity.id, activity.type);
                                                                            }
                                                                        },
                                                                        attrs: {
                                                                            title: "Aktivität löschen"
                                                                        }
                                                                    },
                                                                    [
                                                                        createElement("i", {
                                                                            class: "fa fa-trash"
                                                                        })
                                                                    ]
                                                                )
                                                            ]
                                                        )
                                                    ]
                                                );
                                            })
                                        )
                                    ]
                                )
                            ])
        ];

        // Füge Interaktions-Info hinzu (wenn Activities vorhanden sind)
        if (this.activities.length > 0) {
            contentElements.push(
                createElement("div", { 
                    class: "pagination-info text-center mb-2 mt-3",
                    style: { fontSize: "0.9rem" }
                }, this.paginationInfo)
            );
        }

        // Füge Pagination hinzu, wenn es mehr als 1 Seite gibt
        if (paginationButtons.length > 0) {
            contentElements.push(
                createElement("div", { class: "pagination-wrapper text-center d-flex justify-content-center" }, paginationButtons)
            );
        }

        return createElement("div", { class: "user-activities" }, [
            createElement("div", { class: "mb-3" }, [
                createElement("div", { class: "card-body" }, contentElements)
            ])
        ]);
    }
});
